import { render, staticRenderFns } from "./Civil-Status.vue?vue&type=template&id=7f25bcb8"
import script from "./Civil-Status.vue?vue&type=script&lang=js"
export * from "./Civil-Status.vue?vue&type=script&lang=js"
import style0 from "./Civil-Status.vue?vue&type=style&index=0&id=7f25bcb8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports